import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeApiCallPost} from "../../../Api/makeApiCall";
import {invokeDAGviaApiPost} from "../../../Api/invokeDag";
import {toastError, toastSuccess} from "../../../utils/toast";
import {toast} from "react-toastify";
import Files from 'react-files';
import {Label} from "react-foundation";

const ProjectionsUpload = ({getDagName = undefined, getDagRunConf = undefined, getUploadUrl, getUploadAdditionalData = () => ({}), setLoading, setDisabled = false, onDagTriggered = undefined, accepts = ['.xlsx', '.csv'], buttonLabel = 'Upload Excel or CSV', validateFile = undefined, getSuccessMessage = (file) => `${file.name} uploaded successfully`}) => {

    const [hasError, setHasError] = useState(false);

    function uploadCsvPostCall(filename, fileContents) {
        let data;
        if (filename.toLowerCase().endsWith('.xlsx')) {
            const uint8Array = new Uint8Array(fileContents);
            const binaryString = uint8Array.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
            const base64Data = btoa(binaryString);

            data = {
                filename: filename,
                data: base64Data,
                encoding: 'base64'
            };
        } else {
            data = {
                filename: filename,
                data: fileContents,
                encoding: 'utf-8'
            };
        }

        console.log("Post Excel ", filename);
        setLoading(true);
        return makeApiCallPost(getUploadUrl(), JSON.stringify({...data, ...getUploadAdditionalData()}));
    }

    function onFilesChange(files) {
        if (setDisabled || hasError || !files.length) {
            setHasError(false);
            return;
        }
        const fileReader = new FileReader();
        const file = files[0];
        fileReader.onload = (loadedFiles) => {
            const validationErrorMessage = validateFile?.(file.name, loadedFiles.target.result);
            if (validationErrorMessage) {
                setLoading(false);
                toastError(toast, validationErrorMessage);
                return;
            }
            return uploadCsvPostCall(file.name, loadedFiles.target.result)
                .then((response) => {
                    setLoading(false);
                    if (response?.apiError)
                        toastError(toast, `File upload failed with error ${JSON.stringify(response.apiError)}`)
                    else if (getDagName) {
                        const dagName = getDagName();
                        invokeDAGviaApiPost(dagName, getDagRunConf(file))
                            .then((response) => {
                                if (response?.apiError)
                                    toastError(toast, `${dagName} DAG trigger failed with error ${JSON.stringify(response.apiError)}`)
                                else {
                                    toastSuccess(toast, `${dagName} DAG triggered successfully with response ${JSON.stringify(response)}`)
                                    onDagTriggered?.()
                                }
                            })
                            .catch(e => {
                                toastError(toast, `${dagName} DAG trigger failed with error ${JSON.stringify(e)}`)
                            })
                    } else {
                        toastSuccess(toast, getSuccessMessage(file, response))
                        onDagTriggered?.()
                    }
                });
        };
        setLoading(true);
        if (file.name.toLowerCase().endsWith('.xlsx')) {
            fileReader.readAsArrayBuffer(file);
        } else {
            fileReader.readAsText(file);
        }
    }

    const handleError = (error, file) => {
        console.error('File error', error, file);
        setHasError(true);
        toastError(toast, `Failed to upload file. Error Code: ${error.code} Message: ${error.message}`)
    };



    return <div className={'upload-button-container'}>
        <Label className={"csv-label"} title={"Upload Projections"}>
        <Files
                className={`hollow button secondary files-dropzone ${setDisabled ? 'disabled' : ''}`}
                onChange={onFilesChange}
                onError={handleError}
                accepts={accepts}
                multiple
                maxFiles={1}
                maxFileSize={20000000}
                clickable={!setDisabled}
                disabled={setDisabled}
            >
                {buttonLabel}
            </Files>
        </Label>
    </div>;
};

ProjectionsUpload.propTypes = {
    getDagName: PropTypes.func,
    getDagRunConf: PropTypes.func,
    getUploadUrl: PropTypes.func.isRequired,
    getUploadAdditionalData: PropTypes.func,
    setLoading: PropTypes.func.isRequired,
    setDisabled: PropTypes.bool,
    onDagTriggered: PropTypes.func,
    accepts: PropTypes.arrayOf(PropTypes.string),
    buttonLabel: PropTypes.string,
    validateFile: PropTypes.func,
    getSuccessMessage: PropTypes.func,
};

export default ProjectionsUpload;